import { TaskCategoriesTreeItemTypes } from 'constants/taskCategories';

export const getTaskCategoriesWithTaskTypesTree = ({
  taskCategories,
  isGlobal,
  isInternalCompany,
  rootParent,
}) =>
  taskCategories.reduce(
    (acc, taskCategory) => [
      ...acc,
      {
        ...taskCategory,
        parentId: rootParent,
        id: taskCategory.taskCategoryId,
        isGlobal,
        type: TaskCategoriesTreeItemTypes.taskCategory,
        isInternalCompany,
      },
      // eslint-disable-next-line no-unsafe-optional-chaining
      ...taskCategory.taskTypes?.reduce(
        (acc, taskType) => [
          ...acc,
          {
            ...taskType,
            parentId: taskType.taskCategoryId,
            id: taskType.taskTypeId,
            type: TaskCategoriesTreeItemTypes.taskType,
            isInternalCompany,
            isGlobal,
          },
        ],
        [],
      ),
    ],
    [],
  );

export const getTaskTypesWithoutCategoryTree = ({
  taskTypes,
  isGlobal,
  rootParent,
  isInternalCompany,
}) =>
  taskTypes?.map(taskType => ({
    ...taskType,
    parentId: rootParent,
    isWithoutCategory: true,
    id: taskType.taskTypeId,
    type: TaskCategoriesTreeItemTypes.taskType,
    isInternalCompany,
    isGlobal,
  }));
